/**
 * Password validation utilities
 */

// Password validation constants
export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_SPECIAL_CHARS = "!@#$%^&*()";
export const PASSWORD_FORMAT_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()]).{12,}$/;

// Individual password validation checks
export const passwordHasMinLength = password => {
  return password.length >= PASSWORD_MIN_LENGTH;
};

export const passwordHasUppercase = password => {
  return /[A-Z]/.test(password);
};

export const passwordHasLowercase = password => {
  return /[a-z]/.test(password);
};

export const passwordHasSpecialChar = password => {
  return new RegExp(`[${PASSWORD_SPECIAL_CHARS}]`).test(password);
};

export const passwordHasNumber = password => {
  return /\d/.test(password);
};

// Full password validation
export const validatePassword = password => {
  return PASSWORD_FORMAT_REGEX.test(password);
};

// Get detailed validation results
export const getPasswordValidationDetails = password => {
  return {
    passwordLength: passwordHasMinLength(password),
    hasUppercase: passwordHasUppercase(password),
    hasLowercase: passwordHasLowercase(password),
    hasSpecialCharacters: passwordHasSpecialChar(password),
    hasNumber: passwordHasNumber(password),
  };
};

// Password requirements text for display
export const PASSWORD_VALIDATION_RULES = {
  length: {
    text: `${PASSWORD_MIN_LENGTH} characters or longer`,
    key: "passwordLength",
  },
  uppercase: { text: "1 uppercase letter", key: "hasUppercase" },
  lowercase: { text: "1 lowercase letter", key: "hasLowercase" },
  specialChar: {
    text: `1 special character (${PASSWORD_SPECIAL_CHARS})`,
    key: "hasSpecialCharacters",
  },
  number: { text: "1 number", key: "hasNumber" },
};
